"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortAlphaNumOrDate = void 0;
const reA = /[^a-zA-Z]/g;
const reN = /[^0-9]/g;
const sortAlphaNumOrDate = (a, b) => {
    if (a.getTime != null && b.getTime != null) {
        a = "" + a.getTime();
        b = "" + b.getTime();
    }
    else {
        a += "";
        b += "";
    }
    var aA = a.replace(reA, "");
    var bA = b.replace(reA, "");
    if (aA === bA) {
        var aN = parseInt(a.replace(reN, ""), 10);
        var bN = parseInt(b.replace(reN, ""), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
    }
    else {
        return aA > bA ? 1 : -1;
    }
};
exports.sortAlphaNumOrDate = sortAlphaNumOrDate;
